export function calculateDistance(userLatVal, userLongVal, adLocation) {
    if (!userLatVal || !userLongVal) return "Distance N/A";
    if (!adLocation) return "0.0mi";
  
    let adLat, adLong;
    if (typeof adLocation === 'object' && adLocation.latitude !== undefined) {
      adLat = adLocation.latitude;
      adLong = adLocation.longitude;
    } else if (typeof adLocation === 'string') {
      const coords = extractCoordinates(adLocation);
      if (!coords) return "Invalid location";
      [adLat, adLong] = coords;
    } else {
      return "Invalid location";
    }
  
    const R = 3958.8;
    const toRad = deg => deg * Math.PI / 180;
    const dLat = toRad(adLat - userLatVal);
    const dLong = toRad(adLong - userLongVal);
    const a = Math.sin(dLat / 2) ** 2 +
              Math.cos(toRad(userLatVal)) * Math.cos(toRad(adLat)) *
              Math.sin(dLong / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    return distance.toFixed(1) + "mi";
}

export function extractCoordinates(locationString) {
    if (!locationString) return null;
    try {
      const coords = locationString.split(',').map(Number);
      if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
        return coords;
      }
      return null;
    } catch {
      return null;
    }
}
/* eslint-disable */
/**
 * Posta kodu doğrulama ve adres bilgilerini getirme
 * @param {string} postalCode - Doğrulanacak posta kodu
 * @returns {Promise} - Konum bilgilerini içeren promise
 */
const API_TOKEN = process.env.VUE_APP_LOCATION_API_KEY;

// Google Maps script'ini dinamik olarak yüklemek için yardımcı fonksiyon
const loadGoogleMapsScript = () => {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_TOKEN}`;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

export const validatePostalCode = async (postalCode) => {
  try {
    await loadGoogleMapsScript();
    const geocoder = new window.google.maps.Geocoder();
    
    // Geocoder API'sini promise yapısına çevirelim (10 saniye zaman aşımı ile)
    const response = await new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        reject(new Error('Google Maps API yanıt vermedi (Zaman Aşımı)'));
      }, 10000);

      geocoder.geocode({ address: postalCode }, (results, status) => {
        clearTimeout(timeout);
        if (status === 'OK') {
          resolve({ results, status });
        } else {
          reject(new Error(status));
        }
      });
    });

    if (!response.results || response.results.length === 0) {
      throw new Error('Posta kodu doğrulanamadı veya bulunamadı');
    }

    const result = response.results[0];
    
    let postalTown = null;
    let route = null;
    
    // Google JS API'den gelen bileşenleri ayrıştırarak şehir/ilçe (postal_town veya locality) ve sokak (route) bilgilerini alalım
    result.address_components.forEach(component => {
      if (component.types.includes('postal_town')) {
        postalTown = component.long_name;
      } else if (!postalTown && component.types.includes('locality')) {
        postalTown = component.long_name;
      }
      
      if (component.types.includes('route')) {
        route = component.long_name;
      }
    });

    return {
      isValid: true,
      latitude: result.geometry.location.lat(),
      longitude: result.geometry.location.lng(),
      formattedAddress: result.formatted_address,
      postalTown: postalTown,
      route: route,
      error: null
    };

  } catch (err) {
    console.log("Geocoding Error:", err);
    return {
      isValid: false,
      latitude: null,
      longitude: null,
      formattedAddress: null,
      postalTown: null,
      route: null,
      error: 'Posta kodu doğrulanamadı veya bulunamadı',
    };
  }
};